import React, { useState } from "react";
import { Chip, Btn, LibIcon, StarBtn, FavChip } from "../components/ui";
import { noteFavKey } from "../lib/favs";
import Modal from "../components/Modal";
import { FF, T } from "../lib/constants";
import { noteTime, noteDate } from "../lib/notes";

// Notitieblok in de bibliotheek (build 2.5): je eigen losse notities én je notities bij
// lessen. Laptop: lijst links, geopende notitie rechts. Telefoon: lijst, of de notitie.
export default function NotesBoard({ mob, notes, uid, loading, error, selId, setSelId, onNew, onChange, onDelete, onOpenLesson, status, isFav, toggleFav, favOnly, setFavOnly }) {
  var fav = function (n) { return !!(isFav && isFav(noteFavKey(n))); };
  var [q, setQ] = useState("");
  var [filter, setFilter] = useState("all");
  var [confirm, setConfirm] = useState(false);

  var mine = (notes || []).filter(function (n) { return n.ownerUid === uid; });
  var shown = mine.filter(function (n) {
    if (favOnly && !fav(n)) return false;
    if (filter === "free" && n.kind !== "free") return false;
    if (filter === "lesson" && n.kind !== "lesson") return false;
    if (!q.trim()) return true;
    var s = q.trim().toLowerCase();
    return ((n.title || "") + " " + (n.lessonLabel || "") + " " + (n.text || "")).toLowerCase().indexOf(s) >= 0;
  }).sort(function (a, b) { return (fav(b) - fav(a)) || (noteTime(b) - noteTime(a)); });
  var sel = mine.find(function (n) { return n.id === selId; }) || null;

  function titleOf(n) { return n.kind === "lesson" ? (n.lessonLabel || "Notitie bij les") : (n.title || "Naamloze notitie"); }

  var list = (
    <div style={{ display: "flex", flexDirection: "column", gap: 10, minWidth: 0 }}>
      <div style={{ display: "flex", gap: 8 }}>
        <label htmlFor="nb-zoek" style={{ position: "absolute", left: -9999 }}>Zoeken in notities</label>
        <input id="nb-zoek" value={q} onChange={function (e) { setQ(e.target.value); }} placeholder="Zoeken in notities…"
          style={{ flex: 1, minWidth: 0, minHeight: 44, border: "1px solid " + T.line, borderRadius: 10, padding: "0 12px", fontSize: 15, background: "#fff", fontFamily: FF, color: T.ink, outline: "none" }} />
        <button type="button" aria-label="Nieuwe notitie" title="Nieuwe notitie" onClick={onNew}
          style={{ width: 44, height: 44, borderRadius: 12, border: 0, background: T.primary, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flex: "none" }}><LibIcon name="plus" /></button>
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {toggleFav && <FavChip active={!!favOnly} onClick={function () { setFavOnly(!favOnly); }} />}
        {toggleFav && <span aria-hidden="true" style={{ width: 1, background: T.line, margin: "4px 2px", alignSelf: "stretch" }} />}
        {[["all", "Alles"], ["free", mob || toggleFav ? "Los" : "Losse notities"], ["lesson", "Bij lessen"]].map(function (f) {
          return <Chip key={f[0]} noX active={filter === f[0]} onClick={function () { setFilter(f[0]); }}>{f[1]}</Chip>;
        })}
      </div>
      {loading && <p style={{ color: T.muted, fontSize: 14, margin: 0 }}>Laden…</p>}
      {error && <p role="alert" style={{ color: "#B83232", fontSize: 14, margin: 0 }}>{error}</p>}
      {!loading && shown.length === 0 && (
        <div style={{ textAlign: "center", color: T.muted, fontSize: 14, padding: "24px 12px", border: "2px dashed " + T.line, borderRadius: 14, lineHeight: 1.6 }}>
          {mine.length === 0 ? "Nog geen notities. Maak er een met de +, of schrijf iets bij een les onder ‘Mijn notities’."
            : favOnly && !mine.some(fav) ? "Nog geen favoriete notities. Tik op het sterretje bij een notitie." : "Niets gevonden."}
        </div>
      )}
      {shown.map(function (n) {
        var on = sel && sel.id === n.id;
        return (
          <div key={n.id} style={{ position: "relative", display: "flex" }}>
          <button type="button" onClick={function () { setSelId(n.id); }} aria-current={on ? "true" : undefined}
            style={{ textAlign: "left", background: T.card, border: "1px solid " + (on && !mob ? T.primary : T.line2), borderRadius: 12, padding: toggleFav ? "10px 44px 10px 12px" : "10px 12px", display: "flex", gap: 10, alignItems: "flex-start", cursor: "pointer", fontFamily: FF, width: "100%" }}>
            <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: "50%", background: n.kind === "lesson" ? (n.color || T.primary) : "#8A857B", marginTop: 5, flex: "none" }} />
            <span style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: 3 }}>
              <span style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 15, fontWeight: 800, color: T.ink }}>
                <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{titleOf(n)}</span>
                <span style={{ fontSize: 12, fontWeight: 600, color: T.muted, whiteSpace: "nowrap" }}>{noteDate(n)}</span>
              </span>
              <span style={{ fontSize: 13, color: n.text ? "#4A4740" : "#A39E94", lineHeight: 1.4, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{n.text || "Leeg"}</span>
              {n.kind === "lesson" && <span style={{ fontSize: 12, fontWeight: 700, color: T.muted }}>{"Bij les" + (n.shared ? " · gedeeld met club" : "")}</span>}
            </span>
          </button>
          {toggleFav && <StarBtn on={fav(n)} label={titleOf(n)} onClick={function () { toggleFav(noteFavKey(n)); }} size={20} style={{ position: "absolute", right: 0, top: "50%", marginTop: -22 }} />}
          </div>
        );
      })}
    </div>
  );

  var editor = sel ? (
    <section style={{ background: T.card, border: "1px solid " + T.line2, borderRadius: 16, padding: mob ? "14px" : "18px 20px", display: "flex", flexDirection: "column", gap: 12, minHeight: mob ? 0 : 520 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10 }}>
        {sel.kind === "lesson"
          ? <h2 style={{ margin: 0, fontSize: mob ? 19 : 22, fontWeight: 800, color: T.ink }}>{titleOf(sel)}</h2>
          : <><label htmlFor="nb-titel" style={{ position: "absolute", left: -9999 }}>Titel</label>
              <input id="nb-titel" value={sel.title || ""} placeholder="Titel" onChange={function (e) { onChange(sel, { title: e.target.value }); }}
                style={{ flex: 1, minWidth: 0, border: 0, fontSize: mob ? 19 : 22, fontWeight: 800, color: T.ink, outline: "none", background: "transparent", fontFamily: FF, padding: 0 }} /></>}
        {toggleFav && <StarBtn on={fav(sel)} label={titleOf(sel)} onClick={function () { toggleFav(noteFavKey(sel)); }} style={{ marginLeft: "auto" }} />}
        <span role="status" style={{ fontSize: 12, fontWeight: 700, color: status === "error" ? "#B83232" : status === "saving" ? T.muted : "#2F7D47", whiteSpace: "nowrap" }}>
          {status === "saving" ? "Opslaan…" : status === "saved" ? "Opgeslagen" : status === "error" ? "Niet opgeslagen" : ""}
        </span>
      </div>
      <label htmlFor="nb-tekst" style={{ position: "absolute", left: -9999 }}>Tekst</label>
      <textarea id="nb-tekst" value={sel.text || ""} onChange={function (e) { onChange(sel, { text: e.target.value }); }}
        placeholder="Schrijf hier je notitie"
        style={{ flex: 1, minHeight: mob ? 260 : 360, border: "1px solid " + T.line, borderRadius: 12, padding: 14, fontSize: 15, lineHeight: 1.6, color: T.ink, resize: "vertical", background: "#FFFDF6", fontFamily: FF, outline: "none" }} />
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        {sel.kind === "lesson"
          ? <Btn kind="secondary" onClick={function () { onOpenLesson(sel); }}>Les openen</Btn>
          : <span style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: T.muted }}><LibIcon name="lock" size={14} />Alleen voor jou</span>}
        <Btn kind="danger" onClick={function () { setConfirm(true); }}>Verwijderen</Btn>
      </div>
      {confirm && (
        <Modal onClose={function () { setConfirm(false); }}>
          <h3 style={{ fontSize: 18, color: "#B83232", margin: "0 0 8px", fontWeight: 800, fontFamily: FF }}>Notitie verwijderen?</h3>
          <p style={{ fontSize: 14, color: T.muted, margin: "0 0 16px", fontFamily: FF }}>Dit kan niet ongedaan worden gemaakt.</p>
          <div style={{ display: "flex", gap: 8 }}>
            <Btn kind="secondary" onClick={function () { setConfirm(false); }} style={{ flex: 1 }}>Annuleren</Btn>
            <Btn onClick={function () { setConfirm(false); onDelete(sel); }} style={{ flex: 1, background: "#B83232" }}>Verwijderen</Btn>
          </div>
        </Modal>
      )}
    </section>
  ) : (
    <section style={{ border: "2px dashed " + T.line, borderRadius: 16, minHeight: 520, display: "flex", alignItems: "center", justifyContent: "center", color: T.muted, fontSize: 14, padding: 20, textAlign: "center" }}>
      Kies een notitie, of maak een nieuwe met de +.
    </section>
  );

  if (mob) {
    if (sel) return (
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <button type="button" onClick={function () { setSelId(null); }} style={{ alignSelf: "flex-start", display: "flex", alignItems: "center", gap: 4, background: "none", border: 0, color: T.muted, fontSize: 14, fontWeight: 600, minHeight: 40, cursor: "pointer", fontFamily: FF, padding: 0 }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>Alle notities
        </button>
        {editor}
      </div>
    );
    return list;
  }
  return <div style={{ display: "grid", gridTemplateColumns: "360px minmax(0, 1fr)", gap: 16, alignItems: "start" }}>{list}{editor}</div>;
}
